import { groupBy } from '@cx-modules/utils';

import { type BetsWithBestOdds } from '../types';

interface GetNumberOfColumnsProps {
  betsWithBestOdds: BetsWithBestOdds;
  isPlayerBettingMarket: boolean;
  numberOfColumns: number;
}

export const getNumberOfColumns = ({
  betsWithBestOdds,
  isPlayerBettingMarket,
  numberOfColumns,
}: GetNumberOfColumnsProps): number => {
  const isGroupedBets = betsWithBestOdds.some(b => b?.line?.name !== null && typeof b?.line?.name !== 'undefined');
  const groupedBets = isGroupedBets ? groupBy(betsWithBestOdds, b => b.name) : {};
  const numberOfGroupedBetsColumns = Object.keys(groupedBets).length;

  return isGroupedBets && !isPlayerBettingMarket ? numberOfGroupedBetsColumns : numberOfColumns;
};
